import React, { Component } from "react";
import AttachIcon from "./AttachIcon";
import { EmojiIcon } from "./EmojiIcon";
import { Picker } from "emoji-mart";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import "./emoji-mart.css";
import "./dart_internal.css";
import "./commentEditInput.css";

import {
  MAX_FILE_COMMENTS_IN_BYTES,
  MAX_FILE_COMMENTS_IN_MB
} from "../../utils/Constants/UploadsConstants";
import {
  uuidv4,
  handleFormat,
  sendNotification,
  getFileType,
  getFileName
} from "../../utils";
import UploadFile from "../../utils/UploadFile";

import AttachedFileProgress from "./AttachedFileProgress";
import {
  setIsDoingACommentWithFile,
  unsetIsDoingACommentWithFile
} from "../../actions/CommentAction";
import MainMentionInput2 from "./MainMentionInput2";
import { updateComment } from "../../actions/CommentAction";
import AttachedFile from "./AttachedFile";

// import { KEY_CODE_ENTER } from '../../utils'
import { Tooltip } from "antd";
class CommentEditInput extends Component {
  constructor(props) {
    super(props);
    const { comment } = this.props;
    this.uploadInputRef = React.createRef();
    this.state = {
      isOriginalAttachedFileDeleted: comment.attachedFile ? false : true,
      hasAttachedFile: comment.attachedFile ? true : false,
      editComment: {
        newCommentValue: comment.comment
      },
      mentionsEdit: [],
      showEmojiPicker: false,
      attachedFile: null,
      isUploadingFile: false,
      isInputBoxWidthCalculated: false,
      inputBoxWidth: "0px"
    };
    this.myRef = React.createRef();
  }

  deleteOriginalAttachedFile = () =>
    this.setState({ isOriginalAttachedFileDeleted: true });

  handleEditCommentTextChange = e => {
    this.setState(state => {
      const { editComment } = state;
      return {
        editComment: {
          ...editComment,
          newCommentValue: e.target.value
        }
      };
    });
  };

  onAddMentionEdit = (id, display) => {
    this.setState(state => ({
      mentionsEdit: [
        ...state.mentionsEdit.filter(r => r.id !== id),
        { id, display }
      ]
    }));
  };

  addEmojiToCommentEdit = item => {
    this.setState(state => ({
      editComment: {
        ...state.editComment,
        newCommentValue: `${state.editComment.newCommentValue} ${item.native} `
      },
      showEmojiPicker: false
    }));
  };
  onClickPickerEmojiComments = () => {
    this.setState(currentState => {
      return {
        showEmojiPicker: !currentState.showEmojiPicker
      };
    });
  };

  submitCommentEdit = (fileToSend = null) => {
    const {
      mentionsEdit,
      editComment,
      isOriginalAttachedFileDeleted,
      hasAttachedFile
    } = this.state;
    const { comment, afterSendEditComment, itemSelected } = this.props;
    let finalComment = "";
    let finalMentions = [];

    if (
      (editComment.newCommentValue && editComment.newCommentValue.length > 0) ||
      (itemSelected && fileToSend)
    ) {
      finalComment = editComment.newCommentValue;

      finalMentions = mentionsEdit
        .filter(r => finalComment.indexOf(`@[${r.display}](${r.id})`) > -1)
        .map(r => {
          if (finalComment.indexOf(`@[${r.display}](${r.id})`) > -1) {
            finalComment = finalComment.replace(
              `@[${r.display}](${r.id})`,
              r.display
            );
            return {
              user: r.id,
              nickName: r.display
            };
          }
          return null;
        });

      let finalFileToSend = null;
      if (hasAttachedFile && !isOriginalAttachedFileDeleted) {
        finalFileToSend = comment.attachedFile;
      } else {
        finalFileToSend = fileToSend;
      }
      this.props.updateComment(
        comment._id,
        finalComment,
        finalMentions,
        finalFileToSend
      );

      this.setState(
        {
          mentionsEdit: []
        },
        () => afterSendEditComment()
      );
    }
  };

  handleOnSubmitCommentEdit = () => {
    const { attachedFile, isUploadingFile } = this.state;
    const { setIsEditing } = this.props;

    if (attachedFile === null) {
      this.submitCommentEdit();
    } else if (!isUploadingFile) {
      this.setState(
        {
          isUploadingFile: true
        },
        () => {
          this.onClickUpload();
        }
      );
    }
    setIsEditing(); // cambiar a isEditing
  };

  onClickUpload = () => {
    const { attachedFile } = this.state;
    const {
      user,
      clientId,
      clientName,
      setIsDoingACommentWithFile
    } = this.props;

    if (attachedFile) {
      setIsDoingACommentWithFile();
      const uploadFileObject = new UploadFile(clientId, clientName, user);
      uploadFileObject
        .checkIsSetAccelerateConfiguration()
        .then(() => {
          uploadFileObject.startUpload(
            attachedFile,
            this.setUploadObject,
            this.onProgressUpload,
            this.onSuccessUploadFile
          );
        })
        .catch(error => {
          console.error("error catch ", error);
        });
    } else {
      // console.log('seleccione archivo')
    }
  };
  onSuccessUploadFile = file => {
    const { unsetIsDoingACommentWithFile } = this.props;
    const formattedFile = {
      originalURL: file.futureFileURL,
      type: getFileType(file),

      name: getFileName(file),
      fileSize: file.size,
      fileSizeFormat: file.sizeFormat,
      uuid: file.uuid
    };
    this.submitCommentEdit(formattedFile);

    this.cleanAttachedFile();
    unsetIsDoingACommentWithFile();
  };

  onProgressUpload = (file, e) => {
    const { attachedFile } = this.state;
    if (attachedFile.uuid === file.uuid) {
      this.setState((state, props) => {
        const { attachedFile } = state;

        return {
          ...state,
          attachedFile: {
            ...attachedFile,
            state: "inprogress",
            progress: (e.loaded / e.total) * 100
          }
        };
      });
    }
  };

  setUploadObject = (file, uploadObject) => {
    const { attachedFile } = this.state;
    if (attachedFile.uuid === file.uuid) {
      this.setState((state, props) => {
        const { attachedFile } = state;

        return {
          ...state,
          attachedFile: {
            ...attachedFile,
            uploadObject
          }
        };
      });
    }
  };
  cleanAttachedFile = () => {
    this.setState({
      attachedFile: null,
      isUploadingFile: false
    });
  };
  cancelUpload = () => {
    const { attachedFile } = this.state;
    const { unsetIsDoingACommentWithFile, unsetIsEditing } = this.props;
    attachedFile.uploadObject.abort();
    this.setState(
      (state, props) => {
        return {
          ...state,
          isUploadingFile: false,
          attachedFile: {
            ...state.attachedFile,
            progress: 0,
            state: "waiting",
            uploadObject: null
          }
        };
      },
      () => {
        unsetIsDoingACommentWithFile();
        unsetIsEditing();
      }
    );
  };

  handleOnClickUploadFile = () => this.uploadInputRef.current.click();

  handleSelectFile = e => {
    const { intl } = this.props;
    const { length } = e.target.files;
    e.persist();
    const firstFilePosition = 0;
    if (
      length > 0 &&
      e.target.files[firstFilePosition].size <= MAX_FILE_COMMENTS_IN_BYTES
    ) {
      const ext = e.target.files[firstFilePosition].name.split(".").slice(-1);
      const uuid = uuidv4();
      const s3Name = `${uuid}.${ext}`;
      const newFile = {
        uuid,
        s3Name,
        ext,
        applyRkg: true,
        uploadObject: null,
        file: e.target.files[firstFilePosition],
        name: e.target.files[firstFilePosition].name,
        size: e.target.files[firstFilePosition].size,
        sizeFormat: handleFormat(e.target.files[firstFilePosition].size),
        type: e.target.files[firstFilePosition].type,
        state: "waiting",
        progress: 0
      };
      let reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[firstFilePosition]);
      reader.onloadend = file => {
        if (file.total === 0) {
          console.log("problemas leyendo ");
        } else {
          this.setState({ attachedFile: newFile });
        }
      };
    } else if (
      e.target.files[firstFilePosition] &&
      e.target.files[firstFilePosition].size > MAX_FILE_COMMENTS_IN_BYTES
    ) {
      sendNotification(
        "error",
        intl,
        `${intl.formatMessage({
          id: "asset_exceeds_max_file"
        })}  ${MAX_FILE_COMMENTS_IN_MB} MB`
      );
    }
    this.uploadInputRef.current.value = "";
  };

  sendAudioMessage = audioData => {
    if (audioData) {
      const extInfo = audioData.type.split("/");
      const ext = extInfo[1];
      const uuid = uuidv4();
      const s3Name = `${uuid}.${ext}`;

      const newFile = {
        uuid,
        s3Name,
        ext,
        applyRkg: true,
        uploadObject: null,
        file: audioData.blob,
        name: "usuario",
        size: audioData.blob.size,
        sizeFormat: handleFormat(audioData.blob.size),
        type: audioData.type,
        state: "waiting",
        progress: 0
      };

      this.setState({ attachedFile: newFile }, this.onClickUpload);
    }
  };

  componentDidMount() {
    const { isInputBoxWidthCalculated } = this.state;
    if (!isInputBoxWidthCalculated) {
      this.setState({ isInputBoxWidthCalculated: true });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { appWidth } = this.props;

    const {
      isInputBoxWidthCalculated: prevIsInputBoxWidthCalculated
    } = prevState;
    if (
      this.myRef.current &&
      (!prevIsInputBoxWidthCalculated || appWidth !== prevProps.appWidth)
    ) {
      const inputBoxWidth = this.myRef.current.getBoundingClientRect().width;
      this.setState({ inputBoxWidth: `${inputBoxWidth}px` });
    }
  }

  render() {
    const { comment, usersMentions, intl } = this.props;
    const {
      isOriginalAttachedFileDeleted,
      attachedFile,
      isUploadingFile,
      editComment: { newCommentValue },
      showEmojiPicker,
      inputBoxWidth
    } = this.state;

    const placeholderMessage = intl.formatMessage({ id: "edit_your_comment" });
    return (
      <React.Fragment>
        {comment.attachedFile && !isOriginalAttachedFileDeleted && (
          <div
            className={`original-attached ${
              comment.attachedFile && comment.attachedFile.type !== "video"
                ? "is-display"
                : "fixed-width"
            }`}
            style={{ "--opacity-img-edit": 0.2 }}
          >
            <AttachedFile attachedFile={comment.attachedFile} />
            <Tooltip placement="bottom" title={"borrar"}>
              <span
                className="edit_comment_remove"
                onClick={this.deleteOriginalAttachedFile}
              >
                {/* <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 0 24 24" width="32px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z" /></svg> */}
              </span>
            </Tooltip>
          </div>
        )}

        <div className="c-answer__block" ref={this.myRef}>
          <div>
            <input
              type="file"
              onChange={this.handleSelectFile}
              ref={this.uploadInputRef}
              hidden
            />
            {attachedFile && (
              <AttachedFileProgress
                attachedFile={attachedFile}
                cancelUpload={this.cancelUpload}
                cleanAttachedFile={this.cleanAttachedFile}
                isUploadingFile={isUploadingFile}
              />
            )}
          </div>
          <div style={{ width: inputBoxWidth }}>
            <MainMentionInput2
              handleOnChangeInput={this.handleEditCommentTextChange}
              inputValue={newCommentValue}
              handleKeyDown={this.handleKeyDownAnswer}
              placeholderValue={placeholderMessage}
              usersMentions={usersMentions}
              comment={comment}
              onAddHandler={this.onAddMentionEdit}
              showAudioRecorder={isOriginalAttachedFileDeleted}
              sendAudioMessagehandler={this.sendAudioMessage}
            />
          </div>
          <div className="c-answer__block-actions">
            <div className="block-actions">
              <Tooltip placement="top" title="Emojis">
                <span
                  className={this.state.showEmojiPicker ? "active" : ""}
                  onClick={this.onClickPickerEmojiComments}
                >
                  <EmojiIcon />
                </span>
              </Tooltip>

              <Tooltip
                placement="top"
                title={intl.formatMessage({
                  id: "attach_file"
                })}
              >
                {isOriginalAttachedFileDeleted && (
                  <span>
                    <AttachIcon
                      onClick={() => this.handleOnClickUploadFile()}
                    />
                  </span>
                )}
              </Tooltip>
            </div>
            <div className="block-actions-buttons" style={{ display: "flex" }}>
              <div
                className="block-actions-button small"
                onClick={this.props.afterSendEditComment}
                style={{
                  backgroundColor: "#081e33",
                  border: "1px solid #0096D6",
                  width: "110px",
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {intl.formatMessage({ id: "cancel_button" })}
              </div>
              <div
                className="block-actions-button small"
                onClick={this.handleOnSubmitCommentEdit}
              >
                {intl.formatMessage({ id: "edit_permission" })}
              </div>
            </div>
          </div>
          {showEmojiPicker && (
            <div
              className="dart-picker-emoji-answer"
              tabIndex="1"
              ref="divdartpickeremojianswer"
            >
              <Picker
                native={true}
                darkMode={true}
                showPreview={true}
                title={intl.formatMessage({
                  id: "set_emoji"
                })}
                emoji="point_up"
                autoFocus={true}
                perLine={12}
                onSelect={this.addEmojiToCommentEdit}
              />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : "",
    itemSelected: state.comments.itemSelected,
    workclient: state.client.workclient,
    appWidth: state.app.width
  };
};

const mapDispatchToProps = {
  setIsDoingACommentWithFile,
  unsetIsDoingACommentWithFile,
  updateComment
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CommentEditInput))
);
